const variable={
    DEFAULT_DOMAIN:"defaultdomain"
}
export default variable;